<header class="app-topbar">
  <div class="page-container topbar-menu">
    <div class="d-flex align-items-center gap-2">
      <app-logo-box />
      <!-- Sidebar Menu Toggle Button -->
      <button class="sidenav-toggle-button px-2" (click)="toggleMobileMenu()">
        <i class="ri-menu-5-line fs-24"></i>
      </button>

      <!-- Horizontal Menu Toggle Button -->
      <button class="topnav-toggle-button px-2" (click)="toggleMobileMenu()" data-bs-toggle="collapse"
        data-bs-target="#topnav-menu-content">
        <i class="ri-menu-5-line fs-24"></i>
      </button>


      <div class="topbar-item d-none d-md-flex">
        @if (title && subTitle) {
        <div>
          <h4 class="page-title fs-18 fw-bold mb-0">{{title}}</h4>
          <ol class="breadcrumb m-0 mt-1 py-0">
            <li class="breadcrumb-item"><a [routerLink]="'/'">{{breadcrumbRoot}}</a></li>
            <li class="breadcrumb-item active">{{title}}</li>
            <li class="breadcrumb-item active">{{subTitle}}</li>
          </ol>
        </div>
        }@else{
        <h4 class="page-title fs-18 fw-bold mb-0">{{title}}</h4>
        }
      </div>
    </div>

    <div class="d-flex align-items-center gap-2">
      <div class="topbar-item d-none d-sm-flex">
        <button class="topbar-link" (click)="changeTheme()" id="light-dark-mode" type="button">
          @if (color === 'light') {
          <i class="ri-moon-line fs-22"></i>
          } @else {
          <i class="ri-moon-line fs-22"></i>
          }
        </button>
      </div>

      <div class="topbar-item nav-user">
        <div class="dropdown" ngbDropdown>
          <a ngbDropdownToggle class="topbar-link drop-arrow-none px-2" data-bs-toggle="dropdown" data-bs-offset="0,19"
            type="button" aria-haspopup="false" aria-expanded="false">
            <span class="d-lg-flex flex-column gap-1 d-none">
              <h5 class="my-0">{{user?.fullname}}</h5>
            </span>
            <i class="ri-arrow-down-s-line d-none d-lg-block align-middle ms-2"></i>
          </a>
          <div ngbDropdownMenu class="dropdown-menu-end">
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">{{ user?.email }}</h6>
            </div>

            <div class="dropdown-divider"></div>

            <a (click)="logout()" class="cursor-pointer dropdown-item active fw-semibold text-danger">
              <i class="ri-logout-box-line me-1 fs-16 align-middle"></i>
              <span class="align-middle">Sign Out</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
